@if(!isDialogOpen() && isPaymentRequestDataLoading())
{
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@else{
<div class="payment-container"
     [class.fullscreen-mode]="!isDialogOpen()">
    <div mat-dialog-title class="title">
        <span class="heading">Payment Request - ({{typeOfPayment}})</span>
        @if(isDialogOpen())
        {
        <div class="title-actions">
            <button mat-icon-button (click)="openInNewTab()" class="new-tab">
                <mat-icon>open_in_new</mat-icon>
            </button>

            <button mat-dialog-close mat-icon-button (click)="closeDialog()">
                <mat-icon class="close-icon-color">cancel</mat-icon>
            </button>
        </div>
        }
    </div>
    <div #dialogContent mat-dialog-content>
        <form [formGroup]="paymentRequestForm">
            <div class="header-content">
                @if (showReturnReason) {
                <mat-form-field subscriptSizing="dynamic" class="fullLength">
                    <mat-label style="color: red;">Rejected Reason</mat-label>
                    <input matInput formControlName="returnReason" readonly>
                </mat-form-field>
                }

                @if (isRejectionRequested){
                <div class="rejection-request">
                    <mat-icon formControlName="rejectionWarning">warning</mat-icon>
                    <span>Action required: Partner has requested this payment be reversed and rejected.</span>
                </div>
                }

                <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Matter</mat-label>
                    <input readonly matInput formControlName="matterName" />
                </mat-form-field>

                @if (isDateTransactionVisible) {
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Transaction Date</mat-label>
                        <input matInput
                               [matDatepicker]="dateTransactionPicker"
                               formControlName="dateTransaction"
                               placeholder="dd/MM/yyyy"  [max]="currentDate"/>
                        <mat-datepicker-toggle matSuffix [for]="dateTransactionPicker" />
                        <mat-datepicker #dateTransactionPicker />
                        @if (paymentRequestForm.get('dateTransaction')?.touched &&
                        paymentRequestForm.get('dateTransaction')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Transaction Time</mat-label>
                        <input matInput
                               type="time"
                               formControlName="transactionTime" />
                    </mat-form-field>
                </div>
                }

                <div class="sticky-actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterNo }})
                        </a>
                        <button type="button" mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
            </div>

            <mat-tab-group class="request-tab" color="accent" [animationDuration]="'0ms'" [disableRipple]="true">
                <mat-tab label="Request Details">
                    <div [ngClass]="{
                            'tab-content-wrapper-return': isDialogOpen() && showReturnReason,
                            'tab-content-wrapper': isDialogOpen() && !showReturnReason,
                            'extended-tab-content-return-wrapper': !isDialogOpen() && showReturnReason,
                            'extended-tab-content-wrapper': !isDialogOpen() && !showReturnReason
                          }">
                        <div class="form-content">
                            <mat-form-field *ngIf="!isInternational">
                                <mat-label>Payment Method</mat-label>
                                <mat-select formControlName="chapsRequired">
                                    <mat-option [value]="false">Faster Payment</mat-option>
                                    <mat-option [value]="true">CHAPS</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-checkbox *ngIf="paymentRequestForm.get('chapsRequired')?.value && !isInternational"
                                          class="halfWidth"
                                          formControlName="isPropertyPurchase">
                                Is this transaction related to a property purchase?
                            </mat-checkbox>


                            <mat-form-field *ngIf="paymentRequestForm.get('chapsRequired')?.value && paymentRequestForm.get('isPropertyPurchase')?.value && !isInternational">
                                <mat-label>Purpose Code</mat-label>
                                <mat-select formControlName="purchaseCode">
                                    <mat-option *ngFor="let p of purchaseCodes" [value]="p.code">
                                        {{ p.code }} - {{ p.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="fullLength">
                                <mat-label>Are monies being returned directly to the client?</mat-label>
                                <mat-select formControlName="isMoniesReturned">
                                    <mat-option [value]="true">Yes</mat-option>
                                    <mat-option [value]="false">No</mat-option>
                                </mat-select>
                                @if (paymentRequestForm.get('isMoniesReturned')?.invalid) {
                                <mat-error>Please select Yes or No.</mat-error>
                                }
                            </mat-form-field>

                            @if(paymentRequestForm.get('isMoniesReturned')?.value === false){
                            <mat-form-field class="fullLength">
                                <mat-label>If no, please explain.</mat-label>
                                <textarea matInput formControlName="returnMoniesExplanationIfNo"></textarea>
                                @if (paymentRequestForm.get('returnMoniesExplanationIfNo')?.touched && paymentRequestForm.get('returnMoniesExplanationIfNo')?.hasError('required')) {
                                <mat-error>
                                    Please provide an explanation if monies are not being returned directly to the client.
                                </mat-error>
                                }
                            </mat-form-field>
                            }

                            <mat-form-field class="fullLength">
                                <mat-label>Reason for payment</mat-label>
                                <input matInput formControlName="reason" />
                                @if (paymentRequestForm.get('reason')?.invalid) {
                                <mat-error>Reason is required.</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="fullLength">
                                <mat-label>Are you the matter partner on this matter?</mat-label>
                                <mat-select formControlName="matterPartner">
                                    <mat-option [value]="true">Yes</mat-option>
                                    <mat-option [value]="false">No</mat-option>
                                </mat-select>
                            </mat-form-field>

                            @if (paymentRequestForm.get('matterPartner')?.value === false) {
                            <mat-form-field class="fullLength">
                                <mat-label>
                                    Reason for requesting payment on a matter you are not the matter partner for
                                </mat-label>
                                <textarea matInput formControlName="nonPartnerReason"></textarea>
                                @if (paymentRequestForm.get('nonPartnerReason')?.hasError('required')) {
                                <mat-error>Reason is required when selecting No.</mat-error>
                                }
                            </mat-form-field>
                            }

                            @if (isInternational || paymentRequestForm.get('chapsRequired')?.value === true) {
                            <mat-form-field class="fullLength">
                                <mat-label>Address</mat-label>
                                <textarea matInput formControlName="address" [required]="!!isInternational" [readonly]="!canEditFields"></textarea>
                                @if (paymentRequestForm.get('address')?.touched && paymentRequestForm.get('address')?.hasError('required')) {
                                <mat-error>Address for payment is required.</mat-error>
                                }
                            </mat-form-field>
                            }

                            @if (showPayeeSelect) {
                            <mat-form-field>
                                <mat-label>Payee</mat-label>
                                <mat-select multiple required panelClass="sw-multi-select-panel" [formControl]="payeeClients"
                                            [errorStateMatcher]="payeeErrorMatcher"
                                            (selectionChange)="onPayeeClientsChange()"
                                            (openedChange)="onPayeeSelectOpened($event)">
                                    @for (name of clientOptions; track name) {
                                    <mat-option [value]="name">{{ name }}</mat-option>
                                    }
                                </mat-select>
                                <mat-error>Please select at least one payee.</mat-error>
                            </mat-form-field>
                            } @else {
                            <mat-form-field>
                                <mat-label>Payee</mat-label>
                                <input matInput formControlName="name" [readonly]="!canEditFields" />
                            </mat-form-field>
                            }
                            <mat-form-field>
                                <mat-label>Amount</mat-label>
                                @if (!isInternational) {
                                <span matTextPrefix>£&nbsp;</span>
                                }
                                <input matInput formControlName="amount" [readonly]="!canEditFields" appCurrencyInput />
                            </mat-form-field>
                            @if (paymentType) {
                            <mat-form-field>
                                <mat-label>Vat Amount</mat-label>
                                <input matInput formControlName="vatAmount" [readonly]="!canEditFields" appCurrencyInput/>
                            </mat-form-field>
                            }

                            <mat-form-field>
                                <mat-label>Client Bank</mat-label>

                                <mat-select formControlName="clientBankAccount">

                                    <mat-option *ngFor="let account of filteredBankAccounts"
                                                [value]="account">

                                        {{ account.accountId }} - {{ account.description }}

                                    </mat-option>

                                </mat-select>
                            </mat-form-field>

                            @if (isInternational) {
                            <mat-form-field>
                                <mat-label>Currency</mat-label>
                                <mat-select formControlName="currency">
                                    <mat-option *ngFor="let c of currencyDropdown" [value]="c.currencyCode">
                                        {{ c.currencyCode }} - {{ c.symbol }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>Please select currency code.</mat-error>
                            </mat-form-field>
                            }

                            @if (!isInternational) {
                            <mat-form-field>
                                <mat-label>Bank name</mat-label>
                                <input matInput formControlName="bankName" [readonly]="!(canEditFields || accountsEditableFields)" />
                            </mat-form-field>
                            }

                            @if (showLinkToOpenMatter()) {
                            <div class="actionstep-matter-overview">
                                <div class="link-wrapper">
                                    <a [href]="actionstepMatterOverviewUrl"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Open Actionstep Matter ({{ matterNo }}) Overview
                                    </a>
                                    <button type="button" mat-icon-button
                                            class="small-copy-btn"
                                            [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                                            matTooltip="Copy link to clipboard"
                                            matTooltipPosition="below">
                                        <mat-icon>content_copy</mat-icon>
                                    </button>
                                </div>
                                <div class="warning-box">
                                    You must be logged into Actionstep under the same jurisdiction.
                                </div>
                            </div>
                            }


                            @if (isInternational) {
                            <mat-form-field>
                                <mat-label>Intermediary account number / IBAN</mat-label>
                                <input matInput formControlName="intermAccountNo" [readonly]="!canEditFields" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Intermediary SWIFT/Bic code</mat-label>
                                <input matInput formControlName="intermSwift" [readonly]="!canEditFields" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Intermediary bank name</mat-label>
                                <input matInput formControlName="intermBankName" [readonly]="!(canEditFields || accountsEditableFields)" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Intermediary reference</mat-label>
                                <input matInput formControlName="interReference" [readonly]="!canEditFields" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Bank</mat-label>
                                <input matInput formControlName="bankName" [readonly]="!(canEditFields || accountsEditableFields)" />
                                @if (paymentRequestForm.get('bankName')?.invalid) {
                                <mat-error>Please enter the name of the bank.</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Beneficiary account no</mat-label>
                                <input matInput formControlName="finalBeneficiaryAccNo" [readonly]="!canEditFields" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Beneficiary swift code</mat-label>
                                <input matInput formControlName="finalBeneficiarySwift" [readonly]="!canEditFields" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Beneficiary reference</mat-label>
                                <input matInput formControlName="finalReference" [readonly]="!canEditFields" />
                            </mat-form-field>
                            }

                            @if (!isInternational) {
                            <div class="form">
                                <mat-form-field>
                                    <mat-label>Sort code</mat-label>
                                    <input matInput maxlength="6" inputmode="numeric" formControlName="sortCode" [readonly]="!canEditFields"
                                           (keypress)="allowOnlyDigits($event)" (input)="sanitizeSortCode($event)" />
                                    @if (paymentRequestForm.get('sortCode')?.invalid && paymentRequestForm.get('sortCode')?.touched) {
                                    <mat-error>Please enter a valid 6-digit sort code (e.g. 123456).</mat-error>
                                    }
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Account number</mat-label>
                                    <input matInput formControlName="accountNo" [readonly]="!canEditFields" />
                                    @if (paymentRequestForm.get('accountNo')?.invalid && paymentRequestForm.get('accountNo')?.touched) {
                                    <mat-error>Please enter a valid Account Number.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            }

                            <mat-form-field>
                                <mat-label>Payee Reference</mat-label>
                                <input matInput formControlName="reference" [readonly]="!canEditFields" />
                            </mat-form-field>

                            @if (isTransactionRefVisible) {
                            <mat-form-field>
                                <mat-label>Transaction reference</mat-label>
                                <input matInput formControlName="transactionReference" />
                            </mat-form-field>
                            }

                            <mat-form-field>
                                <mat-label>Note to accounts</mat-label>
                                <input matInput formControlName="otherInfo" [readonly]="!canEditFields" />
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Have the account details been verbally verified by telephone?</mat-label>
                                <mat-select formControlName="isAccountDetailsVerifies">
                                    <mat-option [value]="'Yes'">Yes</mat-option>
                                    <mat-option [value]="'No'">No</mat-option>
                                </mat-select>
                            </mat-form-field>

                            @if (paymentRequestForm.get('isAccountDetailsVerifies')?.value === 'Yes') {
                            <div class="form">
                                <mat-form-field color="accent">
                                    <mat-label>Verification Date</mat-label>
                                    <input matInput
                                           [matDatepicker]="pickerVerifyDate"
                                           [max]="currentDate"
                                           formControlName="telephoneVerificationDate"
                                           [readonly]="!canEditFields">
                                    <mat-datepicker-toggle matSuffix color="mat-accent" [for]="pickerVerifyDate"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerVerifyDate></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Spoke To</mat-label>
                                    <input matInput formControlName="verificationSpokeTo" [readonly]="!canEditFields">
                                </mat-form-field>
                            </div>
                            }

                            @if (paymentRequestForm.get('isAccountDetailsVerifies')?.value === 'No') {
                            <mat-form-field class="reason-field fullLength">
                                <mat-label>Reason for not confirming details by phone</mat-label>
                                <input matInput formControlName="verificationNoReason" [readonly]="!canEditFields">
                            </mat-form-field>
                            }

                            <mat-form-field>
                                <mat-label>Partner authorising</mat-label>
                                <mat-select formControlName="partnerAuthorisingId">
                                    <mat-option *ngFor="let item of partnerList" [value]="item.id">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                @if (paymentRequestForm.get('partnerAuthorisingId')?.touched && paymentRequestForm.get('partnerAuthorisingId')?.hasError('required')) {
                                <mat-error>Partner authorising is required.</mat-error>
                                }
                            </mat-form-field>


                            @if (paymentRequestForm.get('dateAuthorized')?.value) {
                            <mat-form-field color="accent">
                                <mat-label>Date authorised</mat-label>
                                <input matInput
                                       [matDatepicker]="picker1"
                                       placeholder="Date authorised"
                                       formControlName="dateAuthorized" />
                                <mat-datepicker-toggle matSuffix color="mat-accent" [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                            }

                            <div class="date-time-row">
                                <mat-form-field color="accent" class="date-field">
                                    <mat-label>Requested Date</mat-label>
                                    <input matInput
                                           [matDatepicker]="dateRequestedPicker"
                                           formControlName="dateRequested"
                                           placeholder="dd/MM/yyyy"/>
                                    <mat-datepicker-toggle matSuffix [for]="dateRequestedPicker" />
                                    <mat-datepicker #dateRequestedPicker />
                                </mat-form-field>

                                <mat-form-field color="accent" class="time-field">
                                    <mat-label>Requested Time</mat-label>
                                    <input matInput
                                           type="time"
                                           formControlName="requestedTime" />
                                </mat-form-field>
                            </div>

                            <mat-form-field appearance="fill" class="upload-doc">
                                <mat-label>
                                    Files to upload
                                </mat-label>
                                <input matInput formControlName="fileUpload"
                                       [value]="displayFile.join(', ')"
                                       placeholder="Please select a file"
                                       readonly>
                                <button (click)="fileInput.click()" mat-icon-button matSuffix>
                                    <mat-icon>upload_file</mat-icon>
                                </button>
                                @if (displayFile.length > 0) {
                                <button (click)="clearUpload(fileInput)" mat-icon-button matSuffix>
                                    <mat-icon>clear</mat-icon>
                                </button>
                                }
                                <input type="file" id="fileInput" (change)="onFilesSelected($event.target)" #fileInput multiple hidden>
                                @if (isFileUploadRequired && displayFile.length === 0 && paymentRequestForm.get('fileUpload')?.touched) {
                                <mat-error>At least one file must be uploaded.</mat-error>
                                }
                            </mat-form-field>

                            @if(isStageAccounts1){
                            <mat-form-field class="fullLength">
                                <mat-label>I confirm that the payee name matches the bank details.</mat-label>
                                <mat-select formControlName="confirmPayeeName">
                                    <mat-option [value]="true">Yes</mat-option>
                                    <mat-option [value]="false">No</mat-option>
                                </mat-select>
                            </mat-form-field>
                            }

                            @if (isStageAccounts1 && paymentRequestForm.get('confirmPayeeName')?.value === false){
                            <mat-form-field class="fullLength bold-field">
                                <mat-label>Please explain why the payee name does not match the bank details.</mat-label>
                                <textarea matInput formControlName="noMatchReason"></textarea>
                                @if (
                                paymentRequestForm.get('noMatchReason')?.touched && paymentRequestForm.get('noMatchReason')?.hasError('required')) {
                                <mat-error>
                                    Reason is required when selecting "No".
                                </mat-error>
                                }
                            </mat-form-field>
                            }

                            @if (isStagePartner2 && paymentRequestForm.get('confirmPayeeName')?.value === false){
                            <mat-form-field class="fullLength">
                                <mat-label>Partner response to payee name mismatch.</mat-label>
                                <textarea matInput formControlName="partnerResponse"></textarea>
                                @if (
                                paymentRequestForm.get('partnerResponse')?.touched && paymentRequestForm.get('partnerResponse')?.hasError('required')) {
                                <mat-error>
                                    Give reply to Accounts team.
                                </mat-error>
                                }
                            </mat-form-field>
                            }

                            @if (paymentData.comments?.length) {
                            @for (item of paymentData.comments; let i = $index; track i) {
                            <mat-form-field>
                                <mat-label>
                                    {{ i + 1 }}. {{ StagesLabel[item.stageId ?? item.currentStageId!] }}
                                </mat-label>
                                <textarea matInput [value]="item.comment" readonly></textarea>
                            </mat-form-field>
                            }
                            }

                            <mat-form-field class="fullLength" *ngIf="!disableButtons">
                                <mat-label>
                                    Add Comments/Notes
                                </mat-label>
                                <textarea matInput formControlName="comments"></textarea>
                            </mat-form-field>
                            @if (showFundsCheckedByPartner) {
                            <mat-checkbox class="fullLength" formControlName="fundsCheckedByPartner">
                                I confirm that available funds have been checked.<span class="important">*</span>
                            </mat-checkbox>
                            }

                            @if (FundsCheckedPartnerText) {
                            <mat-checkbox class="fullLength"
                                          formControlName="fundsCheckedByPartner">
                                Available funds have been checked by partner.
                            </mat-checkbox>
                            }

                            @if (showFundsCheckedByAccounts) {
                            <mat-checkbox class="fullLength" formControlName="fundsCheckedByAccounts">
                                I confirm that available funds have been checked.<span class="important">*</span>
                            </mat-checkbox>
                            }

                            @if (FundsCheckedAccountsText) {
                            <mat-checkbox class="fullLength"
                                          formControlName="fundsCheckedByAccounts">
                                Available funds have been checked by accounts.
                            </mat-checkbox>
                            }
                            @if(isAmountReleased)
                            {
                            <mat-checkbox class="fullLength" formControlName="isCheckedLedger">I have confirmed that I have checked the ledger for available funds.<span class="important">*</span></mat-checkbox>
                            }

                            @if(showFundsCheckedByPartner || showFundsCheckedByAccounts){
                            <div class="fullLength">
                                <mat-checkbox formControlName="isPartnerCertified">I certify that<span class="important">*</span></mat-checkbox>
                                <ul>
                                    <li>The information contained in this form has been verified by me and is accurate.</li>
                                    <li>This payment is in accordance with the Accounts Policy (including Direct Policy)* and the AML and Sanctions Policy.</li>
                                    <li>I have undertaken source of funds checks and that they are satisfactory.</li>
                                </ul>
                                <p>If any doubt, please contact a senior member of the Compliance Team.</p>
                            </div>
                            }
                        </div>
                    </div>
                </mat-tab>

                <mat-tab label="Attachments" [disabled]="!hasAttachments">
                    <div [ngClass]="{
                            'tab-content-wrapper-return': isDialogOpen() && showReturnReason,
                            'tab-content-wrapper': isDialogOpen() && !showReturnReason,
                            'extended-tab-content-return-wrapper': !isDialogOpen() && showReturnReason,
                            'extended-tab-content-wrapper': !isDialogOpen() && !showReturnReason
                          }">
                        @if(paymentData)
                        {
                        <xp-attachment-list *ngIf="hasAttachments" [attachments]="paymentData.documents" />
                        }
                        @else
                        {
                        <xp-attachment-list *ngIf="hasAttachments" [attachments]="[]" />
                        }
                    </div>
                </mat-tab>

                <mat-tab label="Audit">
                    <xp-audit-log [ngClass]="{
                            'dialog-mode-rejected': isDialogOpen() && showReturnReason,
                            'dialog-mode': isDialogOpen() && !showReturnReason,
                            'extended-mode-rejected': !isDialogOpen() && showReturnReason,
                            'extended-mode': !isDialogOpen() && !showReturnReason
                                      }"
                                  [requestId]="getRequestId" [requestType]="RequestType.Payment" [showPaginator]="false" />
                </mat-tab>
            </mat-tab-group>
        </form>
    </div>
    <div mat-dialog-actions class="action-buttons">
        <div class="left-buttons">
            <button [disabled]="!paymentData || !paymentData.documentAvailable" (click)="downloadDocuments(paymentData.id,'Payment')" mat-raised-button color="accent" matTooltip="Download documents">
                Download Attachments
            </button>
        </div>
        <div [class.right-buttons]="!isDialogOpen()">
            <span class="approve-btn-wrapper"
                  [matTooltip]="isApproveBlockedByRpaFailure ? 'The RPA failed for this request, so it cannot be approved to the next stage.' : ''"
                  matTooltipShowDelay="300">
                <button [disabled]="disableButtons || paymentRequestForm.invalid || isApproveBlockedByRpaFailure"
                        (click)="approveRequest()"
                        mat-raised-button
                        color="accent">
                    {{approveBtn}}
                </button>
            </span>
            <button *ngIf="previousWorkflows.length == 0" [disabled]="disableButtons" (click)="delete()" mat-raised-button color="warn">
                Reject
            </button>
            <button *ngIf="previousWorkflows.length > 0" [disabled]="disableButtons" mat-raised-button [matMenuTriggerFor]="rejectMenu" color="warn">
                Reject
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #rejectMenu="matMenu">
                <ng-container *ngFor="let previousStage of previousWorkflows">
                    <span [matTooltip]="isReturnDisabled(previousStage.stageOrder) ? 'This request must be returned to the Accounts team for reversal.' : ''"
                          matTooltipPosition="right"
                          matTooltipShowDelay="300">

                        <button mat-menu-item
                                [disabled]="isReturnDisabled(previousStage.stageOrder)"
                                (click)="returnRequest(previousStage.stageOrder, previousStage.rejectStatus || 'Return')">
                            {{ previousStage.rejectStatus }}
                        </button>
                    </span>
                </ng-container>
                <mat-divider></mat-divider>


                <span [matTooltip]="isStagePartner2Return ? 'This request must be returned to the Accounts team for reversal.' : ''"
                      matTooltipPosition="right"
                      matTooltipShowDelay="300">

                    <button mat-menu-item
                            [disabled]="isStagePartner2Return"
                            (click)="delete()">
                        Reject
                    </button>
                </span>
            </mat-menu>
        </div>
    </div>
</div>
}
